import React from 'react'
import Layout from '../Layout/layout'
import First_pane from './Blocks/First_pane'

const Biote_888 = () => {
  return (
    <Layout>
    <First_pane />
    </Layout>
  )
}

export default Biote_888